import { CssBaseline, Grid, styled } from "@mui/material";
import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../AuthProvider";
import { pages } from "../pages/pages";
import MasterHeader from "./MasterHeader";

const MasterLayout: React.FunctionComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();
    useEffect(() => {
        if (!isAuthenticated && location.pathname !== pages.login) {
            navigate(pages.login);
        }
        if (isAuthenticated && location.pathname === pages.login) {
            navigate(pages.home);
        }
    }, [isAuthenticated, navigate, location]);
    return (
        <>
            <Grid container wrap="nowrap">
                <CssBaseline />
                <MasterHeader />
            </Grid>
            <ContentContainer>
                <Outlet />
            </ContentContainer>
        </>
    );
};

export default MasterLayout;

const ContentContainer = styled("div")({
    marginTop: 56,
});
